import React from "react";
import { Link } from "react-router-dom";
import { InstagramOutlined, WhatsAppOutlined, PhoneFilled } from "@ant-design/icons";

import "./footer.component.styles.scss";
import {
  PHONE_HUMAN,
  PHONE_TEL,
  WHATSAPP_URL,
  INSTAGRAM_URL,
  INSTAGRAM_HANDLE,
  conversions,
} from "../../../lib/analytics";
import { useLang } from "../../../lib/i18n";

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  const { lang, lp } = useLang();
  const isEn = lang === "en";
  return (
    <footer className="lvs-footer">
      <span className="lvs-footer__watermark" aria-hidden="true">
        laviens<em>.</em>
      </span>

      <div className="lvs-footer__inner">
        <div className="lvs-footer__lead">
          <p className="eyebrow lvs-footer__eyebrow">
            {isEn ? "Laviens · Wellness Studio" : "Laviens · Studio Olistico"}
          </p>
          <p className="lvs-footer__line">
            {isEn ? (
              <>
                <em>Your well-being,</em> our priority.
              </>
            ) : (
              <>
                <em>Il tuo benessere,</em> la nostra priorità.
              </>
            )}
          </p>
          <div className="lvs-footer__ctas">
            <Link
              to={lp("/booking")}
              className="lvs-footer__btn lvs-footer__btn--primary"
              onClick={() => conversions.book("footer")}
            >
              {isEn ? "Book a session →" : "Prenota una sessione →"}
            </Link>
            <a
              href={`tel:${PHONE_TEL}`}
              className="lvs-footer__btn"
              onClick={() => conversions.phone("footer")}
            >
              {PHONE_HUMAN}
            </a>
            <a
              href={WHATSAPP_URL}
              className="lvs-footer__btn lvs-footer__btn--whatsapp"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => conversions.whatsapp("footer")}
            >
              WhatsApp
            </a>
          </div>
        </div>

        <div className="lvs-footer__cols">
          <div>
            <p className="eyebrow">{isEn ? "Visit" : "Visita"}</p>
            <p>Sesto Fiorentino</p>
            <p>{isEn ? "Florence, Italy" : "Firenze, Italia"}</p>
          </div>
          <div>
            <p className="eyebrow">{isEn ? "Hours" : "Orari"}</p>
            <p>{isEn ? "Weekdays 8 AM – 6 PM" : "Feriali 8 – 18"}</p>
            <p>{isEn ? "Weekends 9 AM – 8 PM" : "Festivi 9 – 20"}</p>
          </div>
          <div>
            <p className="eyebrow">{isEn ? "Navigation" : "Navigazione"}</p>
            <p>
              <Link to={lp("/treatments")}>
                {isEn ? "Treatments" : "Trattamenti"}
              </Link>
            </p>
            <p>
              <Link to={lp("/journal")}>Journal</Link>
            </p>
            <p>
              <Link to={lp("/about")}>
                {isEn ? "About" : "Chi siamo"}
              </Link>
            </p>
            <p>
              <Link to={lp("/gift-card")}>Gift Card</Link>
            </p>
            <p>
              <Link
                to={lp("/booking")}
                onClick={() => conversions.book("footer_nav")}
              >
                {isEn ? "Book" : "Prenota"}
              </Link>
            </p>
            <p>
              <Link to={lp("/contact")}>
                {isEn ? "Contact" : "Contatti"}
              </Link>
            </p>
          </div>
          <div>
            <p className="eyebrow">
              {isEn ? "Massages by area" : "Massaggi dove"}
            </p>
            <p>
              <Link to={lp("/massaggi-firenze")}>
                {isEn ? "Massages Florence" : "Massaggi Firenze"}
              </Link>
            </p>
            <p>
              <Link to={lp("/massaggi-sesto-fiorentino")}>
                {isEn
                  ? "Massages Sesto Fiorentino"
                  : "Massaggi Sesto Fiorentino"}
              </Link>
            </p>
            <p>
              <Link to={lp("/massaggi-toscana")}>
                {isEn ? "Massages Tuscany" : "Massaggi Toscana"}
              </Link>
            </p>
          </div>
          <div>
            <p className="eyebrow">{isEn ? "Treatments" : "Trattamenti"}</p>
            <p>
              <Link to={lp("/massaggio-svedese")}>
                {isEn ? "Swedish Massage" : "Massaggio Svedese"}
              </Link>
            </p>
            <p>
              <Link to={lp("/massaggio-decontratturante")}>
                {isEn ? "Deep-Tissue Massage" : "Massaggio Decontratturante"}
              </Link>
            </p>
            <p>
              <Link to={lp("/massaggio-linfodrenante")}>
                {isEn
                  ? "Lymphatic Drainage Massage"
                  : "Massaggio Linfodrenante"}
              </Link>
            </p>
            <p>
              <Link to={lp("/massaggio-ayurvedico")}>
                {isEn ? "Ayurvedic Massage" : "Massaggio Ayurvedico"}
              </Link>
            </p>
            <p>
              <Link to={lp("/aromaterapia")}>
                {isEn ? "Aromatherapy" : "Aromaterapia"}
              </Link>
            </p>
            <p>
              <Link to={lp("/skin-care")}>Skin Care</Link>
            </p>
          </div>
          <div>
            <p className="eyebrow">{isEn ? "Follow" : "Segui"}</p>
            <p>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => conversions.instagram("footer")}
              >
                <InstagramOutlined className="lvs-footer__icon" />{" "}
                {INSTAGRAM_HANDLE}
              </a>
            </p>
            <p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => conversions.whatsapp("footer_social")}
              >
                <WhatsAppOutlined className="lvs-footer__icon" /> WhatsApp
              </a>
            </p>
            <p>
              <a
                href={`tel:${PHONE_TEL}`}
                onClick={() => conversions.phone("footer_social")}
              >
                <PhoneFilled className="lvs-footer__icon" /> {PHONE_HUMAN}
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="lvs-footer__base">
        <span>
          © {year} Laviens.{" "}
          {isEn ? "All rights reserved." : "Tutti i diritti riservati."}
        </span>
        <span className="lvs-footer__legal">
          <Link to={lp("/privacy")}>Privacy</Link>
          <span aria-hidden="true"> · </span>
          <Link to={lp("/cookie-policy")}>Cookie Policy</Link>
        </span>
        <span className="lvs-footer__sig">
          {isEn ? "Care · Calm · Cadence" : "Cura · Calma · Cadenza"}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
